import React from 'react';
import { motion } from 'framer-motion';
import { XCircle } from 'lucide-react';
export function Problem() {
  return <section className="py-12 md:py-16 px-4 bg-brand-dark border-t border-white/5" data-id="element-160">
      <div className="max-w-4xl mx-auto" data-id="element-161">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-162">
          <h2 className="text-4xl md:text-6xl text-white mb-6" data-id="element-163">
            EL PROBLEMA <span className="text-red-500" data-id="element-164">NO ES</span> LA FALTA DE
            OPORTUNIDADES.
          </h2>
          <div className="space-y-4 text-lg md:text-xl text-gray-300 font-medium max-w-3xl mx-auto" data-id="element-165">
            <p data-id="element-166">
              Miles de personas buscan generar ingresos extra o aprender un
              oficio rentable.
            </p>
            <p className="text-white font-bold" data-id="element-167">
              El verdadero problema es no saber por dónde empezar.
            </p>
            <p data-id="element-168">
              Muchos terminan perdiendo tiempo, dinero y meses de prueba y error
              porque nadie les explica el proceso completo de forma clara.
            </p>
          </div>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-169">
          {['No saber cuánto cobrar', 'No conocer materiales', 'No tener experiencia', 'No saber conseguir clientes'].map((item, i) => <motion.div key={i} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-brand-gray p-6 rounded-xl border border-red-500/20 flex items-center gap-4" data-id="element-170">
              <XCircle className="text-red-500 w-8 h-8 flex-shrink-0" data-id="element-171" />
              <span className="text-xl font-bold text-gray-200" data-id="element-172">{item}</span>
            </motion.div>)}
        </div>
      </div>
    </section>;
}